import { FC, MouseEvent } from 'react';

import { useBrowserModalControls } from '@telialt/common-hooks/src/useBrowserModalControls';
import { NetflixVas } from '@telialt/common-order-cart/src/entries/NetflixVas';
import { EntryWithNetflix } from '@telialt/models/src/EshopModel';
import { NETFLIX_UPGRADE_MODAL_KEY } from '@telialt/utils/src/eshopConstants';

import { useCartQuery } from '../../hooks/queries/useCartQuery';
import { useInteractionWithCartIndicator } from '../../hooks/useInteractionWithCartIndicator';

export const NetflixVasConnected: FC<{ entry: EntryWithNetflix; showSwitch: boolean }> = ({ entry, showSwitch }) => {
    const { cart } = useCartQuery();
    const { openModal } = useBrowserModalControls(NETFLIX_UPGRADE_MODAL_KEY);
    const isCartBusy = !!useInteractionWithCartIndicator();

    const plan = entry.product?.code;
    const isPremium = plan === 'NETFLIX_PREMIUM_PRODUCT';
    const premiumPrice = cart?.netflixPremiumMonthlyPrice;
    const switchHandler = (event: MouseEvent<HTMLElement>) => openModal(undefined, event.currentTarget as HTMLElement);

    return (
        <NetflixVas
            isPremium={isPremium}
            premiumPrice={premiumPrice}
            onChange={showSwitch ? switchHandler : undefined}
            isLoading={isCartBusy}
        />
    );
};
